import { ICrudUrl, ISearchQuery } from 'interfaces'
import { ISearchDoctorQuery } from 'pages/menuDoctor/interfaces'
import { EBookingStatus, EExamStatus } from 'pages/patientBooking/enums'
import { getBeginDate, getEndDate } from 'utils'

// import { addDays } from 'utils'

// import { addDays } from 'utils'

export const SEARCH_DOCTOR_QUERY: ISearchQuery<ISearchDoctorQuery> = {
  query: {},
  limit: 50,
  offset: 0,
  order_by: 'created_at',
  asc: true
}

export const SEARCH_QUERY_DEFAULT: ISearchQuery<any> = {
  query: {},
  limit: 50,
  offset: 0,
  order_by: 'created_at',
  asc: false
}

export const SEARCH_QUERY_BOOKING_DEFAULT: ISearchQuery<any> = {
  query: {
    name: '',
    status: [
      EBookingStatus.Created,
      EBookingStatus.Canceled,
      EBookingStatus.Confirmed,
      EBookingStatus.InProgress,
      EBookingStatus.Finished
    ]
  },
  limit: 50,
  offset: 0,
  order_by: 'created_at',
  asc: false
}

export const SEARCH_QUERY_BOOKING_EXAM_STATUS_DEFAULT: ISearchQuery<any> = {
  query: {
    name: '',
    exam_status: [
      EExamStatus.UnKnow,
      EExamStatus.Confirmed,
      EExamStatus.Waiting,
      EExamStatus.DataCollection,
      EExamStatus.InProgress,
      EExamStatus.Finished,
      EExamStatus.Canceled
    ],
    status: [EBookingStatus.InProgress, EBookingStatus.Finished]
  },
  limit: 50,
  offset: 0,
  order_by: 'created_at',
  asc: false
}
const clinicId = localStorage.getItem('clinic_id')
export const SEARCH_QUERY_PATIENT_DEFAULT: ISearchQuery<any> = {
  query: { name: '', phone_number: '', clinic_id: Number(clinicId) },
  limit: 50,
  offset: 0,
  order_by: 'updated_at',
  asc: false
}

export const SEARCH_QUERY_WORKING_SCHEDULE_DEFAULT: ISearchQuery<any> = {
  query: {},
  limit: 50,
  offset: 0,
  order_by: 'weekday'
}

export const SEARCH_QUERY_URL = {
  Doctors: {
    name: 'doctor',
    search: '/clinic-doctor/search',
    delete: '/clinic-doctor',
    update: '/clinic-doctor/update',
    create: '/clinic-doctor/create',
    fieldData: 'doctors'
  } as ICrudUrl,
  ClinicRoom: {
    name: 'clinicRoom',
    search: '/clinic-room/search',
    delete: '/clinic-room',
    update: '/clinic-room/update',
    create: '/clinic-room/create',
    fieldData: 'rooms'
  } as ICrudUrl,
  ClinicUser: {
    name: 'clinicUser',
    search: '/clinic-users/search',
    delete: '/clinic-users',
    update: '/clinic-users/update',
    create: '/clinic-users/create',
    fieldData: 'clinic_users'
  } as ICrudUrl,
  ClinicRole: {
    name: 'clinicRole',
    search: '/clinic-roles/search',
    delete: '/clinic-roles',
    update: '/clinic-roles/update',
    create: '/clinic-roles/create',
    fieldData: 'clinic_roles'
  } as ICrudUrl,
  WorkingSchedule: {
    name: 'workingSchedule',
    search: '/clinic/working-schedule',
    delete: '/clinic/working-schedule/delete',
    create: '/clinic/working-schedule/create',
    fieldData: 'working_schedules'
  } as ICrudUrl,
  Booking: {
    name: 'booking',
    search: '/clinic/booking/search',
    fieldData: 'bookings'
  } as ICrudUrl,
  Patient: {
    name: 'patient',
    search: '/clinic/patient/search',
    fieldData: 'patients'
  } as ICrudUrl,
  SubService: {
    name: 'subService',
    search: '/clinic/sub-services/search',
    create: '/clinic/sub-services/',
    update: '/clinic/sub-services/update',
    delete: 'clinic/sub-services/delete',
    fieldData: 'sub_services'
  } as ICrudUrl,
  GroupService: {
    name: 'groupService',
    search: '/clinic/services/search',
    create: '/clinic/services/',
    update: '/clinic/services/update',
    delete: '/clinic/services/delete',
    fieldData: 'services'
  } as ICrudUrl,
  Notification: {
    name: 'notificationService',
    search: '/clinic-notification-log',
    fieldData: 'notifications'
  } as ICrudUrl,
  Transaction: {
    name: 'transactionService',
    search: '/user/transaction',
    fieldData: 'transactions'
  } as ICrudUrl,
  RepoInventory: {
    name: 'repoInventory',
    search: '/clinic/medicines/search',
    fieldData: 'medicines',
    delete: '/clinic/medicines'
  } as ICrudUrl,
  RepoImport: {
    name: 'repoImport',
    search: '/clinic/medicines/import/search',
    create: '/clinic/medicines/',
    fieldData: 'import_medicines',
    delete: 'clinic/medicines/import'
  } as ICrudUrl,
  RepoImportDetail: {
    delete: 'clinic/medicines/import-detail'
  } as ICrudUrl
}

export const SEARCH_BOOKING_QUERY = {
  query: {
    from: getBeginDate(new Date()).getTime(),
    to: getEndDate(new Date()).getTime()
  },
  offset: 0,
  limit: 1000,
  order_by: 'from_time',
  asc: true
}
